import React from 'react';
import { ImageFile } from '~/data/types/images';

const OnlinePriceTag: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 92 95"
    >
      <rect
        x="-1.71163"
        y="0.441944"
        width="27.697"
        height="66.4323"
        rx="2.14321"
        transform="matrix(-0.86143 -0.507876 -0.507876 0.86143 69.5741 29.7525)"
        fill="#FFFEFE"
        stroke="#00D6D1"
        strokeWidth="2.5"
      />
      <circle
        cx="4.5202"
        cy="4.5202"
        r="3.2702"
        transform="matrix(-0.968246 0.250001 0.250001 0.968246 57.8906 23.9648)"
        fill="#FFFEFE"
        stroke="#00D6D1"
        strokeWidth="2.5"
      />
      <path
        d="M58.2859 27.3664C66.9305 22.8433 83.3409 10.3949 74.8218 3.51675C72.4344 1.59572 64.976 1.17678 61.2266 5.78724"
        stroke="#00D6D1"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.7608 48.7938L44.002 51.2733C44.1236 51.5167 44.3584 51.6855 44.6307 51.7246L47.4072 52.1242C48.0932 52.2233 48.3661 53.0547 47.8697 53.531L45.8619 55.4602C45.6646 55.6499 45.5748 55.9227 45.6215 56.1905L46.0953 58.9141C46.212 59.5879 45.4949 60.1019 44.8817 59.7832L42.4002 58.4963C42.1569 58.3701 41.8655 58.3701 41.6215 58.4963L39.14 59.7832C38.5268 60.1019 37.8097 59.5879 37.9271 58.9141L38.4002 56.1905C38.4469 55.9227 38.3571 55.6499 38.1598 55.4602L36.152 53.531C35.6556 53.0547 35.9286 52.2233 36.6145 52.1242L39.391 51.7246C39.6633 51.6855 39.8988 51.5167 40.0204 51.2733L41.2609 48.7938C41.5678 48.1807 42.4539 48.1807 42.7608 48.7938Z"
        stroke="#FBE64D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Component>
  );
};

export default OnlinePriceTag;
